<template>
<transition name="Right">
  <div>
    <Header>
      <div slot="center">联系客服</div>
    </Header>
    <div class="question-img">
      <img src="@/assets/个人中心/question.jpg" alt="">
    </div>
  </div>
</transition>
</template>

<script>
import Header from "@/components/Header/index";
export default {
  name:'Other',
  components:{
    Header
  },
}
</script>

<style lang="less" scoped>
.question-img{
  width: 100vw;
  height: 60vh;
  margin-top: 10vh;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>